<template>
	<div class="cart">
		<v-col class="pt-5">

			<div class="pb-5" v-if="cartData.length == 0 && !loading">
				<div class="pb-5 text-center">
					<v-row class="justify-center">
						<v-col cols="6" sm="5" md="3" class="pb-1">
							<img width="100%" src="/assets/icons/no-cart.png">
						</v-col>
					</v-row>
					<div class="text-body-1 text-sm-h5 font-weight-bold my-auto text-center">Keranjang Anda masih kosong...</div>
					<div class="text-body-2 text-sm-body-1 text-center pt-2">Tambahkan keranjang Anda dengan produk yang tersedia pada toko sekarang</div>
					<div class="pt-4">
						<router-link :to="'/' + store_slug + '/'" class="text-deco">
							<v-btn depressed large color="primary" class="text-capitalize font-weight-bold rounded-lg">Belanja Sekarang</v-btn>
						</router-link>
					</div>
				</div>
			</div>

			<div v-else>
				<v-card class="rounded-lg mb-5" v-if="!loading">
					<v-col class="pa-5">
						<div>
							<!-- <div class="text-uppercase font-weight-bold primary--text text-body-2 pb-2">
								<v-icon color="primary" class="mt-n1">mdi-storefront</v-icon>
								<span class="pl-3">{{cart.store_name}}</span>
							</div> -->

							<v-simple-table class="no-hover-bg table-cart">
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left text-subtitle-2" width="30%">Produk</th>
											<th class="text-center text-subtitle-2">Harga (Rp)</th>
											<th class="text-center text-subtitle-2" width="17%">Jumlah</th>
											<th class="text-center text-subtitle-2">Sub Total (Rp)</th>
											<th class="text-center text-subtitle-2">Hapus</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in cartData" :key="item.product_id">
											<template v-if="item.details">
												<td class="py-5">
													<router-link :to="{ name: 'product-store-detail', params: { id: item.product_id }}" class="text-deco">
														<div class="d-flex">
															<v-card outlined>
																<v-col class="pa-1">
																	<v-img class="rounded-lg" width="70" height="70" :src="(item.details.store_product_product_image) ? item.details.store_product_product_image : '/assets/product/default.png'"></v-img>
																</v-col>
															</v-card>
															<div class="my-auto pl-3">
																<div>{{ item.details.product_name }}</div>
																<!-- <div v-if="item.product_pv > 0">{{ item.product_pv }} PV</div> -->
															</div>
														</div>
													</router-link>
												</td>
												<!-- <td class="text-center" v-if="false">
													{{ item.details.product_price | toNumber }} <sup v-if="item.product_price != item.product_price_origin" class="text-decoration-line-through font-size-10 pink--text">{{item.product_price_origin | toNumber}}</sup>
												</td> -->
												<td class="text-center">
													<!-- <div class="text-decoration-line-through font-size-10 pink--text">
														{{ item.product_price_origin | toNumber }}
													</div> -->
													<div>
														<template v-if="detailStore.store_free_delivery == 'Ya'">
															<template v-if="item.details.product_is_complement == 'Ya'">{{ item.details.store_product_product_price | toNumber }}</template>
															<template v-else>{{ item.details.store_product_product_price_margin | toNumber }}</template>
														</template>
														<template v-else>{{ item.details.store_product_product_price | toNumber }}</template>
													</div>
												</td>
												<td class="my-auto">
													<div class="d-flex py-3">
														<v-btn text x-small color="primary" height="35" :disabled="item.quantity < 2" @click="item.quantity--" @click.stop="update(item.product_id, item.quantity)">
															<v-icon>mdi-minus-circle</v-icon>
														</v-btn>
														<v-currency-field class="input-center" v-model="item.quantity" @blur="update(item.product_id, item.quantity)" dense hide-details="auto"></v-currency-field>
														<v-btn text x-small color="primary" height="35" @click="item.quantity++" @click.stop="update(item.product_id, item.quantity)"  :disabled="item.quantity >= item.details.store_product_stock_balance">
															<v-icon>mdi-plus-circle</v-icon>
														</v-btn>
													</div>
												</td>
												<td class="text-center primary--text font-weight-bold">
													<template v-if="detailStore.store_free_delivery == 'Ya'">
														<template v-if="item.details.product_is_complement == 'Ya'">{{ item.details.store_product_product_price * item.quantity | toNumber }}</template>
														<template v-else>{{ item.details.store_product_product_price_margin * item.quantity | toNumber }}</template>
													</template>
													<template v-else>{{ item.details.store_product_product_price * item.quantity | toNumber }}</template>
												</td>
												<td class="text-center">
													<v-btn text color="pink" @click="removeProduct(item.product_id)">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</td>
											</template>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</div>
						<div>
							<v-card outlined class="hwi-border rounded-lg pa-2" color="green lighten-5">
								<v-row class="px-4">
									<v-col cols="12" sm="4" md="3">
										<div class="text-md-h6 font-weight-bold">Total Belanja</div>
										<div class="text-body-2 grey--text text--darken-1">{{countItem(cartData) | toNumber}} item dari {{cartData.length}} produk</div>
									</v-col>
									<v-col cols="12" sm="5" md="6">
										<div class="text-md-h6 font-weight-bold">Rp {{countPrice(cartData) | toNumber}}</div>
										<div class="text-body-2 grey--text text--darken-1">Belum Ongkos Kirim</div>
									</v-col>
									<v-col cols="3" class="my-auto">
										<v-btn depressed block color="primary" @click="checkoutCart(cartData)" height="40" class="rounded-lg font-weight-bold">Checkout</v-btn>
									</v-col>
								</v-row>
							</v-card>
						</div>
					</v-col>
				</v-card>

				<template v-else>
					<hwiloader :messages="'Sedang memuat data belanja...'"></hwiloader>
				</template>
			</div>

			<!-- productTrend -->
			<!-- <ProductCarousel ref="recomended" type="recomended" :product="genSamples(productSamples, 5)"></ProductCarousel> -->
		</v-col>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// import ProductCarousel from '@/views/store/product/ProductCarousel'
// import debounce from '@/helpers/debounce'

export default {
	components: {
		// ProductCarousel
	},
	data () {
		return {
			loading: false,
			cartData: [],
			store_slug: '',
			detailStore: {},
		}
	},
	computed:{
		...mapState('auth', ['userData']),
		// ...mapState('cart', ['cartData', 'cartPagination']),
		// ...mapState('productExternal', ['productTrend']),
	},
	watch: {
		cartData(newCart) {
			// console.log('newCart', newCart)
			this.countPrice(newCart)
		}
	},
	methods: {
		// ...mapActions('cart', ['getCart', 'updateItemCart', 'removeProductCart', 'getCartDetail']),
		// ...mapActions('productExternal', ['getProductTrend']),
		...mapMutations(['makeAlert']),

		getProductDetails() {
			if (this.cartData.length > 0) {
				this.loading = true
				const these = this
				this.cartData.map(cart => {
					these.$http
					.get(`/store-product/detail-store-product/${this.store_slug}?store_product_id=${cart.product_id}`)
						.then((res) => {
							const data = res.data.data
							cart['details'] = data
						})
						.catch(() => {
							// err = error
						})
				})

				setTimeout(() => { this.loading = false }, 3000)
			} 
		},

		async update(product_id, qty) {
			let existCart = await JSON.parse(localStorage.getItem('hwiecom-cart'))
			
			if (existCart == undefined) {
				// console.log(existCart)
			} else {
				if (existCart.length == 0) {
					// console.log(existCart)
				} else {
					let checkItemIndex = existCart.findIndex(el => el.product_id == product_id )
					let newCart = [] 
					if (checkItemIndex == undefined) {
						// console.log(existCart)
					} else {
						newCart = existCart
						newCart[checkItemIndex].quantity = qty
					}

					localStorage.setItem('hwiecom-cart', JSON.stringify(newCart))
				}
			}
		},
		async removeProduct(product_id) {
			this.loading = await true
			let existCart = await JSON.parse(localStorage.getItem('hwiecom-cart'))
			let checkItemIndex = await existCart.findIndex(el => el.product_id == product_id )

			let newCart = await [] 
			if (checkItemIndex == undefined) {
				console.log(existCart)
			} else {
				newCart = existCart
				newCart.splice(checkItemIndex, 1);
			}

			localStorage.setItem('hwiecom-cart', JSON.stringify(newCart))
			
			setTimeout(() => {
				this.loadCartData()
				this.loading = false
			}, 1000);
		},

		async loadCartData() {
			let cart = await JSON.parse(localStorage.getItem('hwiecom-cart'))
			this.cartData = (cart == undefined) ? [] : cart

			this.getProductDetails()
		},

		countItem(data) {
			// console.log('countItem', data)
			let count = 0
			data.forEach( (el) => {
				count += parseInt(el.quantity)
			});
			return count
		},

		countPrice(data) {
			// console.log('countPrice', data)
			let count = 0
			data.forEach( (el) => {
				if (this.detailStore.store_free_delivery == 'Ya') {
					if (el.details !== undefined) {
						if (el.details.product_is_complement == 'Ya') count += parseInt(el.quantity) * parseInt(el.details.store_product_product_price)
						else count += parseInt(el.quantity) * parseInt(el.details.store_product_product_price_margin)
					}
				} else {
					if (el.details !== undefined) count += parseInt(el.quantity) * parseInt(el.details.store_product_product_price)
				}
			});
			return count
		},

		checkoutCart() {
			this.$router.push('/' + this.store_slug + '/checkout')
		},

		async getStoreDetail() {
			await this.$http
				.get(`/store/detail-store/${this.store_slug}`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
				})
				.catch((error) => {
					// err = error
					console.log(error.response.data.message)
					this.store_slug = ''
					this.$router.push(`/product/${this.idProduct}`).catch(() => {});
				})
		},

		genSamples(data, loop) {
			let newdata = []
			for (let i = 0; i < loop; i++) {
				data.map((item) => {
					let prd = item
					newdata.push(prd)
				})
			}
			
			return newdata
		}
	},

	async created() {
		this.$store.dispatch('setPageTitle', 'Keranjang');
		this.store_slug = await localStorage.getItem('HwiEcomStore')
		let cart = await JSON.parse(localStorage.getItem('hwiecom-cart'))
    this.cartData = (cart == undefined) ? [] : cart

		this.getStoreDetail()
		this.getProductDetails()
	}
};
</script>